module.exports = require('./globalAccessToken');
